<template>
  <a-drawer :visible="visible"
            :title="title"
            width="60%"
            destroyOnClose
            @close="onClose">
    <DetailForm ref="detailForm"
                :infos="formInfo"></DetailForm>
    <div class="footer-but">
      <a-button style="margin-right: 8px"
                @click="onClose"> 关闭 </a-button>
      <!-- <a-button class="first-but" @click="handleIssue('1')"> 编辑 </a-button> -->
      <a-button class="first-but"
                type="primary"
                @click="handleIssue('0')">
        下线
      </a-button>
    </div>
  </a-drawer>
</template>

<script>
import DetailForm from '@/views/Back/components/Detail'
import mixinsBackStack from '@/views/Back/mixins'
import { formInfo } from '../config/config'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: String,
    rows: Object,
    options: Array
  },
  data() {
    return {
      defaultModel: {},
      formInfo
    }
  },
  mixins: [mixinsBackStack],
  components: {
    DetailForm
  },
  watch: {
    rows(val) {
      this.handleResult(val) // 处理结果为想要的格式
    }
  },
  mounted() {},
  methods: {
    handlerPicPathIds(picPath) {
      if (!picPath) return []
      return picPath.reduce((pre, item) => {
        const { fileId } = item.response[0]
        pre.push(fileId)
        return pre
      }, [])
    },
    onClose() {
      this.$emit('shut')
    },
    handleResult(instance) {
      this.options.forEach((ele) => {
        if (instance.moduleId === ele.value) {
          instance.moduleIdStr = ele.label
        }
      })
      this.handlerRichText(instance)
      this.handlerFileAndImg(instance) // 处理附图和附件
      this.dealInfo('formInfo', instance)
    },
    // 处理静态信息
    dealInfo(type, result) {
      if (!result) return
      if (!this[type]) return
      this[type].forEach((item) => {
        const { key } = item
        const v = result[key] || '-'
        item.value = v
      })
    },
    // 处理富文本
    handlerRichText(result) {
      const key1 = 'content'
      const key2 = 'section'
      Object.keys(result).forEach((key) => {
        const isKey1 = key.indexOf(key1) !== -1
        const isKey2 = key.indexOf(key2) !== -1
        if (isKey1 || isKey2) {
          const len = key.length
          const idx = key.slice(-1)
          const ctx = key.substring(0, len - 1)
          const k = `${idx}-${ctx}`
          result[k] = result[key]
        }
      })
      return result
    },
    // 处理附件和附图的数据
    handlerFileAndImg(data) {
      const { systemFile } = data
      if (systemFile && Object.keys(systemFile).length > 0) {
        const { filePath, fileName } = systemFile
        const baseUrl = process.env.VUE_APP_BASE_IMGURL
        data.picture = `<img style="width:100px; height:100px; curse" src="${
          baseUrl + filePath
        }" alt="${fileName}">`
      }
    },
    handleIssue() {
      this.$emit('offline')
    }
  }
}
</script>
